import { styled } from '@linaria/react';
import { Box, Group, Stack } from '@mantine/core';
import { baseWhite, secondaryBase, skyDark } from '../../../../../../styles/design-tokens';
import { Text } from '../../../../../../ui-library/typography/typography';

export const TreeMapTooltip = ({ active, payload }: { active?: boolean; payload?: any[] }) => {
  if (!active || !payload || !payload.length || !payload[0].payload) {
    return null;
  }

  const data = payload[0].payload;
  const { title, name, percentage, actualSize } = data;

  return (
    <TooltipContainer>
      <Stack gap={8}>
        <Group gap={8}>
          <Text color={secondaryBase} size="small">
            {title}
          </Text>
          <Text size="small" weight="bold">{`$${actualSize}`}</Text>
          <Text size="small" color={skyDark}>{`(${percentage.toFixed(2)}%)`}</Text>
        </Group>
        {name && (
          <Text size="small" weight="bold" style={{ wordBreak: 'break-word' }}>
            {name}
          </Text>
        )}
      </Stack>
    </TooltipContainer>
  );
};

const TooltipContainer = styled(Box)`
  background-color: ${baseWhite};
  border-radius: 16px;
  padding: 8px 20px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 300px;
`;
